<template>
    <v-card flat tile>
        <SwitchCategoryDialog :show="showSwitchDialog" :keywords="selectedRows" @close="showSwitchDialog = false" @catUpdated="catUpdated"></SwitchCategoryDialog>
        <DeleteDialog
            :deleteDialog="deleteDialog"
            :selectedDeleteItem="''"
            :deleteLabel="deleteLabel"
            :hint="deleteReleaseHint"
            :loading="deleteLoading"
            @delete="deleteKeywords"
            @close="deleteDialog = false"></DeleteDialog>

        <ConfirmDialog
            :confirmDialog="confirmDialog"
            :selectedItem="''"
            :label="confirmLabel"
            :loading="confirmLoading"
            @confirm="removeKeywordsCategory"
            @close="confirmDialog = false"></ConfirmDialog>
        <ColumnSwitchDialog :headers="headers" :dialog="columnDialog" @close="columnDialog = false" @headerOrderChanged="headerOrderChanged"></ColumnSwitchDialog>
        <v-slide-x-reverse-transition hide-on-leave>
            <div style="position: relative" v-if="selectedRows.length">
                <div style="position: absolute; z-index: 5; top: -38px; right: 16px">
                    <v-chip outlined small class="mr-2 pl-4 pr-1">
                        {{ selectedRows.length }} SELECTED
                        <v-btn class="mx-1" x-small icon @click="selectedRows = []"><v-icon x-small>mdi-close</v-icon></v-btn>
                    </v-chip>
                    <v-divider vertical></v-divider>
                    <v-tooltip top :disabled="!test_set">
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                                <v-btn
                                    elevation="0"
                                    :disabled="$store.state.monitoring_suite_group.id == 2 || test_set"
                                    color="primary"
                                    outlined
                                    rounded
                                    small
                                    class="mr-2"
                                    @click="showSwitchDialog = true">
                                    <v-icon class="mr-1" small>mdi-swap-horizontal</v-icon>category</v-btn
                                >
                            </span>
                        </template>
                        <span>Disabled on Example-Set</span>
                    </v-tooltip>
                    <v-tooltip top :disabled="!test_set">
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                                <v-btn
                                    v-if="selectedRows.filter((x) => x.category_id).length > 0"
                                    elevation="0"
                                    :disabled="$store.state.monitoring_suite_group.id == 2 || test_set"
                                    color="warning"
                                    outlined
                                    rounded
                                    small
                                    class="mr-2"
                                    @click="confirmDialog = true">
                                    <v-icon class="mr-1" small>mdi-tag-remove</v-icon>category</v-btn
                                >
                            </span>
                        </template>
                        <span>Disabled on Example-Set</span>
                    </v-tooltip>
                    <v-tooltip top :disabled="!test_set">
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                                <v-btn elevation="0" :disabled="$store.state.monitoring_suite_group.id == 2 || test_set" outlined rounded color="error" small @click="deleteDialog = true">
                                    <v-icon class="mr-1" small>mdi-delete</v-icon> delete</v-btn
                                >
                            </span>
                        </template>
                        <span>Disabled on Example-Set</span>
                    </v-tooltip>
                </div>
            </div>
        </v-slide-x-reverse-transition>
        <v-slide-x-reverse-transition hide-on-leave>
            <div style="position: relative" v-if="!selectedRows.length">
                <div style="position: absolute; z-index: 5; top: -38px; right: 16px">
                    <v-tooltip top :disabled="!test_set">
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                                <v-btn :disabled="$store.state.monitoring_suite_group.id == 2 || test_set" elevation="0" color="primary" outlined rounded small @click="$emit('showAddKwDialog')">
                                    <v-icon class="mr-1" small>mdi-cloud-upload</v-icon>keywords</v-btn
                                >
                            </span>
                        </template>
                        <span>Disabled on Example-Set</span>
                    </v-tooltip>
                </div>
                <div style="position: absolute; z-index: 5; top: -38px; right: 150px">
                    <v-tooltip top :disabled="!test_set">
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                                <v-btn :disabled="$store.state.monitoring_suite_group.id == 2 || test_set" elevation="0" color="primary" outlined rounded small @click="showCategorySwitchDialog">
                                    <v-icon class="mr-1" small>mdi-swap-horizontal</v-icon>category</v-btn
                                >
                            </span>
                        </template>
                        <span>Disabled on Example-Set</span>
                    </v-tooltip>
                </div>
                <div style="position: absolute; z-index: 5; top: -38px; right: 275px">
                    <div style="display: inline-flex">
                        <filter-menu :fields="filterFields" @filtersUpdated="filtersUpdated" :dense="true"></filter-menu>
                    </div>
                </div>
            </div>
        </v-slide-x-reverse-transition>

        <v-data-table
            :headers="visibleHeaders"
            :items="rankings"
            :loading="loading"
            :sort-desc.sync="sortDesc"
            :sort-by.sync="sortBy"
            :page.sync="page"
            :search.sync="search"
            :items-per-page.sync="itemsPerPage"
            :server-items-length="count"
            :multi-sort="false"
            :footer-props="footerProps"
            @update:options="fetchData"
            fixed-header
            v-model="selectedRows"
            @click:row="onRowClick"
            item-key="_id"
            height="70vh"
            id="rankingstable"
            class="elevation-0">
            <!-- header slot -->
            <template v-for="(header_entry, index) in headers" v-slot:[`header.${header_entry.value}`]="{ header }">
                <span :key="index">
                    <span v-bind:style="{ width: header.width }">
                        <!-- Adding tooltips to header -->

                        <v-btn
                            x-small
                            v-if="index == 0"
                            class="mb-4 mr-2 mt-3"
                            fab
                            color="primary"
                            @click="
                                (e) => {
                                    e.stopPropagation()
                                    columnDialog = true
                                }
                            "
                            ><v-icon>mdi-cog</v-icon></v-btn
                        >
                        <v-tooltip max-width="250" top :disabled="header.tooltip ? false : true">
                            <template v-slot:activator="{ on }">
                                <span v-on="on" style="white-space: nowrap; text-transform: uppercase; font-weight: 500">
                                    {{ header.text }}
                                    <v-icon class="questionIcon" v-if="header.tooltip" x-small>mdi-help-circle-outline</v-icon>
                                </span>
                            </template>
                            <span>
                                <v-row no-gutters class="mb-2">
                                    <div cols="12"><v-icon color="white">mdi-help-circle-outline</v-icon></div>
                                </v-row>

                                <div v-if="header.value.substring(0, 8) == 'ranking_'">
                                    <div class="mt-2">
                                        <span
                                            ><b> Google Ranking for {{ header.text }}:</b>
                                        </span>
                                    </div>
                                    {{ header.tooltip }}
                                    <div class="mt-2">
                                        <span><b> Colorcodes:</b> </span>
                                    </div>
                                    <span v-for="(color, index) in positionColors2" :key="index">
                                        <v-chip x-small class="mr-1 mb-1 mt-1" :color="color">{{ (index == 0 ? index : index * 10) + " - " + (index + 1) * 10 }}</v-chip>
                                    </span>
                                </div>
                                <div v-if="header.value == 'keyword_intent'">
                                    <div class="mt-2">
                                        <span><b> Search Intent:</b> </span>
                                    </div>
                                    {{ header.tooltip }}
                                    <div class="mt-2">
                                        <span><b> Intentions:</b> </span>
                                    </div>
                                    <span v-for="(icon, intent) in intent_icons" :key="intent">
                                        <v-chip class="mr-1 mb-1 mt-1" color="primary">
                                            <v-icon size="16px" class="mr-1">{{ icon }}</v-icon> {{ intent }}
                                        </v-chip>
                                        <div>
                                            <p>{{ intentTooltips[intent] }}</p>
                                        </div>
                                    </span>
                                </div>

                                <div v-else>{{ header.tooltip }}</div>
                            </span>
                        </v-tooltip>
                    </span>
                </span>
            </template>
            <template v-slot:item.keyword="{ item }">
                <div :class="!item.blur ? 'py-2' : 'py-2 blur'" style="padding-left: -5px !important">
                    <span class="rtd pl-2">{{ !item.blur ? item.keyword : item.keyword.slice(0, Math.ceil(item.keyword.length / 3)) }}</span> <br />
                    <div style="white-space: nowrap" v-if="item.category_id">
                        <v-btn icon x-small @click="showAllCatsInTable"
                            ><v-icon x-small>{{ showAllCategories ? "mdi-chevron-right" : "mdi-chevron-left" }}</v-icon></v-btn
                        >
                        <span v-if="item.category_id && showAllCategories" style="white-space: nowrap">
                            <span v-for="(cat, index) in item.category_id.split(';')" :key="cat">
                                <v-icon v-if="index" x-small class="px-0">mdi-chevron-right</v-icon>
                                <v-chip x-small @click="!item.blur ? setCat(item, index) : null"> {{ cat }}</v-chip>
                            </span>
                        </span>
                        <span v-else>
                            <v-chip x-small @click="!item.blur ? setCategory(item) : null">
                                {{ !item.blur ? item.category_id.split(";")[item.category_id.split(";").length - 1] : item.category_id.slice(0, Math.ceil(item.category_id.length / 3)) }}</v-chip
                            >
                        </span>
                    </div>
                </div>
            </template>
            <template v-slot:item.avg_search_volume="{ item }">
                <v-chip outlined class="qchip" color="primary" style="">
                    {{ $helpers.formatNumber(item.avg_search_volume) }}
                </v-chip>
            </template>
            <!-- latest_12_month_search_volume Column -->
            <template v-slot:item.latest_12_month_search_volume="{ item }">
                <v-chip outlined class="qchip" color="primary"> {{ item.latest_12_month_search_volume ? $helpers.formatNumber(item.latest_12_month_search_volume) : "no data" }}</v-chip>
            </template>
            <!-- prev_12_month_search_volume Column -->
            <template v-slot:item.prev_12_month_search_volume="{ item }">
                <v-chip outlined class="qchip" color="primary"> {{ item.prev_12_month_search_volume ? $helpers.formatNumber(item.prev_12_month_search_volume) : "no data" }}</v-chip>
            </template>
            <template v-slot:item.amazon_search_volume="{ item }">
                <v-chip outlined class="qchip" color="primary" style="">
                    {{ $helpers.formatNumber(item.amazon_search_volume * 12) }}
                </v-chip>
            </template>
            <template v-slot:item.internal_search_volume="{ item }">
                <div class="d-flex align-center justify-end" style="white-space: nowrap">
                    <v-chip outlined class="qchip" color="primary" style="">
                        {{ item.internal_search_volume !== undefined && item.internal_search_volume !== null ? $helpers.formatNumber(item.internal_search_volume) : "-" }}
                    </v-chip>
                    <span
                        v-if="
                            item.internal_search_volume !== undefined &&
                            item.internal_search_volume !== null &&
                            item.internal_search_volume_prev !== undefined &&
                            item.internal_search_volume_prev !== null &&
                            item.internal_search_volume_prev > 0
                        "
                        v-bind="(internalSvChange = { change: item.internal_search_volume - item.internal_search_volume_prev })"
                        class="internal-sv-change ml-1">
                        <v-icon size="14" v-if="internalSvChange.change > 0" color="success">mdi-menu-up</v-icon>
                        <v-icon size="14" v-else-if="internalSvChange.change < 0" color="error">mdi-menu-down</v-icon>
                        <span v-else class="internal-sv-change__dash">–</span>
                        <span class="internal-sv-change__value"> {{ Math.abs((internalSvChange.change / item.internal_search_volume_prev) * 100).toFixed(1) }}% </span>
                    </span>
                </div>
            </template>
            <template v-slot:item.item_types="{ item }">
                <SERPTypesCell
                    :serp_items="getSERPItemsObject(item.item_types)"
                    :showAll="showAllSERPItems"
                    @aiclicked="showAIO(item)"
                    @toggle="
                        (e) => {
                            showAllSERPItems = !showAllSERPItems
                        }
                    "></SERPTypesCell>
            </template>

            <template v-slot:item.keyword_intent="{ item }">
                <div style="display: inline-flex" v-if="item.sorted_search_intent">
                    <!-- Haupt-Intent -->
                    <span class="pa-1 d-flex">
                        <v-tooltip max-width="250" color="primary" top>
                            <template v-slot:activator="{ on }">
                                <v-progress-linear
                                    v-on="on"
                                    style="border-radius: 16px; font-size: 14px; width: 70px; margin: auto; opacity: 0.8"
                                    class="white--text intent"
                                    rounded
                                    :value="item.sorted_search_intent[0][1]"
                                    color="primary"
                                    height="32">
                                    <v-icon class="mr-1" size="16px" color="white">{{ intent_icons[item.sorted_search_intent[0][0]] }}</v-icon>
                                    <!-- Name des ersten Intents -->
                                    {{ Math.ceil(item.sorted_search_intent[0][1]) + "%" }}
                                    <!-- Prozentwert des ersten Intents -->
                                </v-progress-linear>
                            </template>
                            <span> {{ item.sorted_search_intent[0][0] }}</span>
                        </v-tooltip>
                    </span>
                    <v-slide-x-transition>
                        <span v-if="show_secondary_intents" style="display: inline-flex">
                            <span v-for="(intent, index) in item.sorted_search_intent.slice(1)" :key="index" class="pa-1">
                                <!-- Alle bis auf den ersten Intent -->
                                <v-tooltip max-width="250" color="primary" top>
                                    <template v-slot:activator="{ on }">
                                        <v-progress-linear
                                            v-on="on"
                                            style="border-radius: 15px; font-size: 14px; width: 70px; margin: auto; opacity: 0.8"
                                            class="white--text intent"
                                            rounded
                                            :value="intent[1]"
                                            color="primary"
                                            height="32">
                                            <v-icon class="mr-1" size="16px" color="white">{{ intent_icons[intent[0]] }}</v-icon>
                                            <!-- Name des sekundären Intents -->
                                            {{ Math.ceil(intent[1]) + "%" }}
                                            <!-- Prozentwert des sekundären Intents -->
                                        </v-progress-linear>
                                    </template>
                                    <span> {{ intent[0] }}</span>
                                </v-tooltip>
                            </span>
                        </span>
                    </v-slide-x-transition>
                    <v-btn
                        @click="
                            (e) => {
                                e.stopPropagation()
                                show_secondary_intents = !show_secondary_intents
                            }
                        "
                        icon
                        class="ma-auto">
                        <v-icon>{{ show_secondary_intents ? "mdi-chevron-left" : "mdi-chevron-right" }}</v-icon>
                    </v-btn>
                </div>
            </template>
            <v-dialog v-model="aiodialog" scrollable persistent :overlay="false" max-width="500px" transition="dialog-transition">
                <v-card>
                    <v-card-title> {{ aio_data.keyword }} </v-card-title>
                    <v-card-subtitle></v-card-subtitle>
                    <v-card-text> saldasdasd asd a </v-card-text>
                </v-card>
            </v-dialog>
            <template v-for="competitor in selectedCompetitors" v-slot:[`item.ranking_${competitor.domain}`]="{ item }">
                <v-dialog
                    id="rankingmenu"
                    style="border-radius: 10px !important"
                    offset-y
                    v-model="menuOpenState[competitor.domain + item.keyword]"
                    rounded
                    @click:outside="menuOpenState[competitor.domain + item.keyword] = false"
                    :close-on-content-click="false"
                    @input="menuOpen(item, competitor.domain)"
                    :key="competitor.domain">
                    <template v-slot:activator="{ on }">
                        <!-- Hier wird der Aktivatorinhalt platziert, z.B. ein Button -->

                        <span>
                            <div class="pr-3" v-bind="(posData = getRankingPosition(item, competitor.domain))">
                                <v-row class="compranking-wrapper" style="flex-wrap: nowrap">
                                    <span class="ml-auto mr-1 my-auto" v-bind="(posData = getRankingPosition(item, competitor.domain))">
                                        <v-chip @click="showAIO(item, competitor.domain)" small v-if="posData.ai_reference" color="purple" class="white--text"
                                            ><span style="font-weight: bold">AI</span></v-chip
                                        >
                                    </span>
                                    <span v-on="on" style="display: inline-flex">
                                        <v-chip class="compranking-wrapper" outlined :color="getColor(posData.position)" :class="posData.ai_reference ? 'qchip ' : ' ml-auto qchip'">
                                            {{ posData.position }}
                                        </v-chip>
                                        <div class="d-flex my-auto ml-1 px-2" v-if="posData.change != null" style="border: 1px solid rgb(187, 187, 187); border-radius: 14px">
                                            <v-icon :color="posData.change ? (posData.change < 0 ? 'red darken-2' : 'green darken-2') : ''" small class="my-auto">{{
                                                posData.change ? (posData.change < 0 ? "mdi-chevron-down" : "mdi-chevron-up") : "mdi-chevron-right"
                                            }}</v-icon>
                                            <span :style="posData.change ? (posData.change < 0 ? 'color: red darken-2' : 'color: green darken-2') : ''" class="rankingchange my-auto">{{
                                                posData.change
                                            }}</span>
                                        </div>
                                    </span>
                                </v-row>
                            </div>
                        </span>
                    </template>
                    <v-list style="color: rgb(255, 255, 255); border-radius: 10px !important">
                        <!-- Ihr bisheriger Tooltip-Inhalt geht hier hinein -->
                        <div class="px-3 py-1" v-if="tooltipMenuData.datasets && tooltipMenuData.datasets.length">
                            <div class="d-flex my-4">
                                <div style="display: block !important" class="px-2">
                                    <div class="mr-1 my-auto quarolbl mb-1" style="font-size: 16px">Position Changes: {{ tooltipMenuData.keyword }}</div>
                                    <div class="my-auto">
                                        <v-chip small class="mr-1">
                                            <img class="ma-auto mr-1" :src="'https://s2.googleusercontent.com/s2/favicons?domain=' + tooltipMenuData.domain + '&sz=42'" alt="" />
                                            {{ tooltipMenuData.domain }}
                                        </v-chip>
                                        <v-chip small>
                                            <v-icon class="mr-1" small>mdi-clock-time-eight-outline</v-icon>
                                            <span v-if="tooltipMenuData.labels[1] != null">
                                                {{ tooltipMenuData.labels[0].substring(0, 10) + " - " + tooltipMenuData.labels[tooltipMenuData.labels.length - 1].substring(0, 10) }}
                                            </span>
                                            <span v-else>
                                                {{ tooltipMenuData.labels[0].substring(0, 10) }}
                                            </span></v-chip
                                        >
                                    </div>
                                </div>
                                <v-spacer class="mr-2"></v-spacer>

                                <v-btn class="ml-2 mr-2" style="background-color: var(--v-primary-base)" icon @click="menuOpenState[competitor.domain + item.keyword] = false">
                                    <v-icon color="white">mdi-close</v-icon></v-btn
                                >
                            </div>
                            <v-divider></v-divider>
                            <v-card-text class="pa-0">
                                <v-row v-if="tooltipMenuData.labels[1] != null">
                                    <v-col cols="12">
                                        <line-chart
                                            v-if="menuOpenState[competitor.domain + item.keyword]"
                                            :dataChart="tooltipMenuData.chartData"
                                            :countGraph2="renderChart"
                                            :options="graphOptions"></line-chart>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" class="pa-0">
                                        <v-divider></v-divider>
                                        <v-data-table id="urlRankingsTable" :headers="tooltipMenuData.tableHeaders" :items="tooltipMenuData.tableRows" hide-default-footer>
                                            <template v-for="(header_entry, index) in tooltipMenuData.tableHeaders" v-slot:[`header.${header_entry.value}`]="{ header }">
                                                <span :key="index">
                                                    <span v-bind:style="{ width: header.width }">
                                                        <!-- Adding tooltips to header -->
                                                        <span style="white-space: nowrap; text-transform: uppercase; font-weight: 500; font-size: 14px">
                                                            {{ header.text }}
                                                        </span>
                                                    </span>
                                                </span>
                                            </template>

                                            <template v-for="(header_entry, index) in tooltipMenuData.tableHeaders" v-slot:[`item.${header_entry.value}`]="{ item }">
                                                <span class="pa-1" v-if="index == 0">
                                                    <span class="d-flex pa-1">
                                                        <div
                                                            class="fav_wrapper my-auto mr-4 ml-3"
                                                            :style="'border-color:' + getColoFromIndex(tooltipMenuData.tableRows.findIndex((d) => d.url == item.url)) + ' !important;'">
                                                            <img class="ma-auto" :src="'https://s2.googleusercontent.com/s2/favicons?domain=' + item.url + '&sz=42'" alt="" />
                                                        </div>
                                                        <span class="my-auto" style="white-space: normal">{{ item.url }}</span>
                                                        <!-- <span class="my-auto">{{ item.url.length > 80 ? item.url.substring(0, 80) + "..." : item.url }}</span> -->
                                                        <v-btn class="ml-1 my-auto" @click="openURL(item.url)" icon primary> <v-icon>mdi-link</v-icon></v-btn>
                                                    </span>
                                                </span>
                                                <span class="pa-1" v-if="index > 0">
                                                    <v-chip class="compranking-wrapper qchip" style="background-color: whitesmoke !important" outlined :color="getColor(item[header_entry.value])">
                                                        {{ item[header_entry.value] || "-" }}
                                                    </v-chip>
                                                </span>
                                            </template>
                                        </v-data-table>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </div>
                        <div v-else>
                            <div class="pa-5 d-flex">
                                <v-spacer class="mr-2"></v-spacer>
                                <v-chip class="mx-auto"> no ranking data</v-chip>
                                <v-spacer class="mr-2"></v-spacer>
                                <v-btn class="ml-2 mr-2" style="background-color: var(--v-primary-base)" icon @click="menuOpenState[competitor.domain + item.keyword] = false">
                                    <v-icon color="white">mdi-close</v-icon></v-btn
                                >
                            </div>
                        </div>
                    </v-list>
                </v-dialog>
            </template>
        </v-data-table>
        <AIOOverviewDialog :dialog="aiodialog" :overviewData="aio_data" @close="aiodialog = false" />
    </v-card>
</template>

<script>
    import monitoringTaxonomy from "@/mixins/monitoringTaxonomy"
    import SwitchCategoryDialog from "./SwitchCategoryDialog"
    import FilterMenu from "./FilterMenu"
    import DeleteDialog from "../dialogs/DeleteDialog.vue"
    import ConfirmDialog from "../dialogs/ConfirmDialog.vue"
    import ColumnSwitchDialog from "../dialogs/ColumnSwitchDialog.vue"
    import { positionColors } from "../helper/global.js"
    import LineChart from "../charts/LineChart"
    import SERPTypesCell from "../keyword-table/SERPTypesCell"
    import { all_serp_items } from "../helper/serp_items.js"
    import AIOOverviewDialog from "./AIOverviewDialog.vue"
    import { releaseHint, entriesCreditUsage } from "../helper/projectStatus"

    export default {
        mixins: [monitoringTaxonomy],
        props: {
            selectedCompetitors: {
                type: Array,
                required: true
            },
            selectedDates: {
                type: Array
            },
            category_id: {
                type: String
            },
            search: {
                type: String
            },
            project_domain: {
                type: String
            },
            exportData: {
                type: Number
            },
            categorized_project: { type: Boolean },
            ai_overview_project: { type: Boolean },
            // optional: für den Credit-Hinweis beim Löschen (Intervall, AIO-Faktor, pausiert)
            project: { type: Object, default: null }
        },
        components: { AIOOverviewDialog, ColumnSwitchDialog, SwitchCategoryDialog, DeleteDialog, FilterMenu, LineChart, ConfirmDialog, SERPTypesCell },
        data() {
            return {
                aio_data: {},
                aiodialog: false,
                showAllSERPItems: false,
                headersData: [
                    { text: "Keyword", value: "keyword", tooltip: "", filterable: false, visible: true },
                    {
                        text: "Google Searches (AVG)",
                        value: "avg_search_volume",
                        align: "end",
                        tooltip: "Shows the average google search volume for a keyword per month.",
                        filterable: false,
                        visible: true
                    },

                    {
                        text: "Google Searches (Current 12 Months)",
                        value: "latest_12_month_search_volume",
                        sortable: true,
                        visible: false,
                        align: "end",
                        tooltip: "The commulated search volume of the last 12 months on google for the keyword."
                    },
                    {
                        text: "Google Searches (Previous 12 Months)",
                        value: "prev_12_month_search_volume",
                        sortable: true,
                        visible: false,
                        align: "end",
                        tooltip: "The commulated search volume of the previous 12 months on google for the keyword."
                    },
                    {
                        text: "Amazon Search Volume (Yearly)",
                        value: "amazon_search_volume",
                        sortable: true,
                        visible: true,
                        align: "end",
                        tooltip: "The yearly search volume on Amazon for the keyword."
                    },
                    {
                        text: "Internal Search Volume (Yearly)",
                        value: "internal_search_volume",
                        sortable: true,
                        visible: true,
                        align: "end",
                        tooltip: "The latest internal search volume for the keyword from the matched internal searches project."
                    },
                    {
                        text: "Search Intent",
                        value: "keyword_intent",
                        sortable: false,
                        align: "end",
                        visible: true,
                        tooltip: "The search intent refers to the user’s motivation behind a search query."
                        // width: "250px"
                    },
                    {
                        text: "SERP Types",
                        value: "item_types",
                        sortable: false,
                        align: "end",
                        visible: true,
                        tooltip: "The search intent refers to the user’s motivation behind a search query."
                        // width: "250px"
                    }

                    // ...existing headers
                ],
                columnDialog: false,
                show_amazon_sv: false,
                show_internal_sv: false,
                show_intents: false,
                show_secondary_intents: false,
                intentTooltips: {
                    informational: "Looking for information on a specific topic, such as “what is SEO?”",
                    navigational: "Navigating to a certain site or page, for instance, “Facebook login page”.",
                    commercial: "Conducting a commercial investigation, that is, researching products or services before making a decision on what to invest in, such as “best SEO tools”.",
                    transactional: "Making a specific purchase, for example, “buy SEO software”."
                },
                intent_icons: { informational: "mdi-information-outline", navigational: "mdi-navigation-outline", commercial: "mdi-shopping-search-outline", transactional: "mdi-shopping-outline" },
                renderChart: 0,
                deleteDialog: false,
                confirmDialog: false,
                showSwitchDialog: false,
                selectedRows: [],
                tooltipMenuData: {},
                menuOpenState: {},
                rankings: [],
                count: 0,
                loading: false,
                deleteLoading: false,
                confirmLoading: false,
                sortDesc: true,
                sortBy: "avg_search_volume",
                page: 1,
                itemsPerPage: 25,
                pagination: {},
                sortDomain: null,
                showAllCategories: false,
                filters: [],
                graphOptions: {
                    tooltips: {
                        callbacks: {
                            label: function (tooltipItems, data) {
                                return data.datasets[tooltipItems.datasetIndex].label + ": " + data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index].toLocaleString()
                            }
                        }
                    },
                    legend: {
                        display: true,
                        labels: {
                            fontSize: 14
                        }
                    },
                    plugins: {
                        legend: {
                            labels: {
                                usePointStyle: true,
                                pointStyle: "rectRounded"
                            }
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                scaleLabel: {
                                    display: true,
                                    labelString: "Google Position (organic)"
                                },
                                ticks: {
                                    reverse: true,
                                    beginAtZero: false,
                                    min: 1, // Mindestwert für die y-Achse
                                    max: 100, // Höchstwert für die y-Achse
                                    stepSize: 10 // Schrittgröße für die y-Achse
                                    // callback: function (value, index, values) {
                                    //     return value.toLocaleString()
                                    // }
                                }
                                // ticks: {
                                //     beginAtZero: true
                                // }
                            }
                        ],
                        xAxes: [
                            {
                                scaleLabel: {
                                    display: true,
                                    labelString: "Dates"
                                }
                                // ticks: {
                                //     beginAtZero: true
                                // }
                            }
                        ]
                    },
                    responsive: true,
                    maintainAspectRatio: false
                }
            }
        },
        computed: {
            company_id() {
                return this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
            },
            svColumnsEnabledForCompany() {
                return ["1547", "1780"].includes(String(this.company_id))
            },
            test_set() {
                return (
                    process.env.VUE_APP_MONITORING_TEST_SET_COMPANY_ID !== this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8) &&
                    !!process.env.VUE_APP_MONITORING_TEST_SET_ID && process.env.VUE_APP_MONITORING_TEST_SET_ID == this.$route.params.id
                )
            },
            positionColors2() {
                return positionColors
            },
            filterFields() {
                let filterFields = [
                    { name: "Keyword", type: "text", key: "keyword" },
                    { name: "Category", type: "text", key: "category_ids" },
                    { name: "Avg Search Volume", type: "number", key: "avg_search_volume" },
                    { name: "Internal Search Volume (Yearly)", type: "number", key: "internal_search_volume" },
                    { name: "SERP Types", type: "array", key: "item_types", options: { values: all_serp_items.map((e) => e.value) }, multiple: true },
                    { name: "Current 12 Month Search Volume", type: "number", key: "latest_12_month_search_volume" },
                    { name: "Previous 12 Month Search Volume", type: "number", key: "prev_12_month_search_volume" }
                ]
                if (!this.ai_overview_project) {
                    filterFields.find((field) => field.key === "item_types").options = { values: all_serp_items.map((e) => e.value).filter((e) => e !== "ai_overview") }
                }
                const avgSearchVolumeIndex = filterFields.findIndex((field) => field.key === "item_types")

                // Competitor mit Domain "lutz.de"
                const competitor = this.selectedCompetitors.find((domain) => domain.domain === this.project_domain)

                if (competitor) {
                    // Neues Filterfeld für den Competitor
                    const competitorField = {
                        domain: competitor.domain,
                        name: `${competitor.domain}`,
                        key: `rankingsMap.${competitor.domain.split(".").join("_")}.position`,
                        type: "number",
                        subfields: [
                            { label: "Organic Position", value: "position", type: "number" },
                            { label: "AI Reference", value: "ai_reference", type: "boolean" }
                        ]
                    }

                    // Füge das neue Filterfeld nach "Avg Search Volume" ein
                    filterFields.splice(avgSearchVolumeIndex, 0, competitorField)
                }

                // Hinzufügen der restlichen Competitors
                this.selectedCompetitors.forEach((domain, index) => {
                    if (domain.domain !== this.project_domain) {
                        const competitorField = {
                            domain: domain.domain,
                            name: `${domain.domain}`,
                            key: `rankingsMap.${domain.domain.split(".").join("_")}.position`,
                            type: "number",
                            subfields: [
                                { label: "Organic Position", value: "position", type: "number" },
                                { label: "AI Reference", value: "ai_reference", type: "boolean" }
                            ]
                        }
                        filterFields.splice(avgSearchVolumeIndex + index, 0, competitorField)
                    }
                })
                if (!this.categorized_project) {
                    //
                    filterFields.splice(1, 1)
                }
                if (this.show_intents) {
                    let indexOfSvH = filterFields.findIndex((e) => e.key == "item_types")
                    Object.keys(this.intent_icons).map((intent) => {
                        let intentheader = {
                            name: "Search Intent - " + intent,
                            key: "search_intent." + intent,
                            type: "number"
                        }
                        filterFields.splice(indexOfSvH + 1, 0, intentheader)
                    })
                }
                return filterFields
            },
            deleteLabel() {
                let str = ""
                let count = this.selectedRows.length
                return str + count + " Keyword(s) permanently?"
            },
            // welche Credits die Löschung der ausgewählten Keywords freigibt (leer ohne Projekt oder bei Pause)
            deleteReleaseHint() {
                return this.project ? releaseHint(this.project, entriesCreditUsage(this.project, this.selectedRows.length)) : ""
            },
            confirmLabel() {
                let str = "Remove catgories of "
                let count = this.selectedRows.filter((x) => x.category_id).length
                return str + count + " Keyword(s)?"
            },
            footerProps() {
                let footerProps = {
                    itemsPerPageOptions: [10, 25, 50, 100],
                    showFirstLastPage: true
                }
                // if (this.$store.state.company_status_monitoring_suite && this.$route.params.id == process.env.VUE_APP_MONITORING_TEST_SET_ID) footerProps["page-text"] = "{0}-{1} of 326628"
                return footerProps
            },
            visibleHeaders() {
                return this.headers.filter((header) => header.visible !== false)
            },
            headers: {
                get() {
                    let h = [
                        ...this.headersData,
                        ...this.selectedCompetitors.map((domain) => ({
                            text: domain.domain,
                            value: `ranking_${domain.domain}`,
                            align: "end",
                            tooltip: "Shows the position and the position change in googles search results based on the selected dates.",
                            filterable: false,
                            visible: true
                        }))
                    ]
                    if (!this.show_intents) {
                        h = h.filter((header) => header.value !== "keyword_intent")
                    }
                    if (!this.svColumnsEnabledForCompany) {
                        h = h.filter((header) => header.value !== "amazon_search_volume")
                        h = h.filter((header) => header.value !== "internal_search_volume")
                    }

                    let indexOfDomain = h.findIndex((e) => e.text == this.project_domain)
                    console.log("indexOfDomain", indexOfDomain)
                    if (indexOfDomain > -1) {
                        let targetIndex = h.length - this.selectedCompetitors.length
                        let removedItem = h.splice(indexOfDomain, 1)[0]
                        h.splice(targetIndex, 0, removedItem)
                    }
                    return h
                },
                set(newHeaders) {
                    this.headersData = newHeaders
                }
            }
            // headers() {
            //     let h = [
            //         { text: "Keyword", value: "keyword" },
            //         { text: "Google Searches (AVG)", value: "avg_search_volume", align: "end", tooltip: "Shows the average google search volume for a keyword" },

            //         // { text: "Category", value: "categories", align: "end", sortable: false },
            //         // Add a header for each domain
            //         ...this.selectedCompetitors.map((domain) => ({
            //             text: domain.domain,
            //             value: `ranking_${domain.domain}`,
            //             align: "end",
            //             tooltip: "Shows the position and the position change in googles search results based on the selected dates."
            //         }))
            //         // {
            //         //     text: "",
            //         //     value: "actions",
            //         //     sortable: false,
            //         //     align: "end",
            //         //     width: 50
            //         // }
            //     ]

            //     console.log(this.project_domain)
            //     let indexOfDomain = h.findIndex((e) => e.text == this.project_domain)
            //     console.log("indexOfDomain", indexOfDomain)
            //     if (indexOfDomain > -1) {
            //         let targetIndex = 2
            //         let removedItem = h.splice(indexOfDomain, 1)[0]
            //         h.splice(targetIndex, 0, removedItem)
            //     }
            //     let indexOfSvH = h.findIndex((e) => e.value == "avg_search_volume")
            //     let intentheader = {
            //         text: "Search Intent",
            //         value: "keyword_intent",
            //         sortable: false,
            //         align: "end",
            //         tooltip: "The search intent refers to the user’s motivation behind a search query."
            //         // width: "250px"
            //     }
            //     if (this.show_intents) {
            //         h.splice(indexOfSvH + 1, 0, intentheader)
            //     }
            //     return h
            // }
        },
        methods: {
            async showAIO(item, competitor) {
                console.log(item)
                console.log(competitor)

                // e.stopPropagation()
                this.aiodialog = true
                const url =
                    (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                        this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                    ) == -1
                        ? process.env.VUE_APP_MONITORING_API_URL
                        : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/aio"
                this.aio_data = {}
                this.aio_data.keyword = item.keyword
                this.aio_data.domain = competitor
                console.log(this.selectedDates)

                const post_data = {
                    keyword: item.keyword,
                    company_id: localStorage.company_id,
                    project_id: this.$route.params.id,
                    date: this.selectedDates[1] ? this.selectedDates[1] : this.selectedDates[0] // Use the current date from the loop
                }

                const response_data = await this.$helpers.axiosPost(url, post_data)
                this.aio_data = { ...response_data.data.results[0] }
                console.log(response_data.data)
            },
            getSERPItemsObject(serp_items) {
                if (!serp_items) return []
                console.log(serp_items)
                if (!this.ai_overview_project) {
                    serp_items = serp_items.filter((item) => item != "ai_overview")
                }
                return serp_items.map((item) => all_serp_items.find((e) => e.value == item))
            },
            headerOrderChanged(changedHeaders) {
                this.headersData = [...changedHeaders]
            },
            getIconText(index) {
                console.log(index)

                console.log(Object.keys(this.intent_icons))
                let keys = Object.keys(this.intent_icons)
                console.log(keys[index])

                return keys[index]
            },
            async removeKeywordsCategory() {
                if (!this.selectedRows.length) return
                this.confirmLoading = true
                console.log(this.selectedRows)
                const url =
                    (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                        this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                    ) == -1
                        ? process.env.VUE_APP_MONITORING_API_URL
                        : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/change/category"
                let post_data = {
                    company_id: localStorage.company_id,
                    project_id: this.$route.params.id,
                    keywords: this.selectedRows
                }
                let response_data = await this.$helpers.axiosPost(url, post_data)
                console.log(response_data.data)
                this.fetchData({
                    sortDesc: this.sortDesc,
                    sortBy: this.sortBy,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage
                })
                this.confirmDialog = false
                this.confirmLoading = false
            },
            showCategorySwitchDialog() {
                if (this.selectedRows.length) {
                    this.showSwitchDialog = true
                    return
                }
                let notifidata = { label: "Please select at least one keyword to change the category!", icon: "mdi-alert-circle-outline", color: "#e5a049" }
                this.$emit("notify", notifidata)
            },
            showAllCatsInTable() {
                event.stopPropagation()
                this.showAllCategories = !this.showAllCategories
            },
            openURL(url) {
                window.open(url, "-blank")
            },
            filtersUpdated(filters) {
                console.log(filters)
                this.filters = filters
                this.fetchData({
                    sortDesc: this.sortDesc,
                    sortBy: this.sortBy,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage
                })
            },
            setCategory(item) {
                event.stopPropagation()
                this.$emit("setCategory", item.category_id)
            },
            setCat(item, index) {
                event.stopPropagation()
                this.$emit("setCategory", item.category_id, index)
            },
            catUpdated() {
                this.showSwitchDialog = false
                this.fetchData({
                    sortDesc: this.sortDesc,
                    sortBy: this.sortBy,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage
                })
                this.selectedRows = []
                let notifidata = { label: "Category successfully changed!", icon: "mdi-check-circle-outline", color: "primary" }
                this.$emit("notify", notifidata)
            },
            onRowClick(row) {
                event.stopPropagation()
                if (row.blur) return
                if (this.isSelecting) return
                console.log(row)
                let entryIndex = this.selectedRows.findIndex((e) => e._id == row._id)
                if (entryIndex === -1) {
                    //select
                    this.selectedRows.push(row)
                } else {
                    //unselect
                    this.selectedRows.splice(entryIndex, 1)
                }
            },
            menuOpen(item, competitor) {
                const isMenuOpen = this.menuOpenState[competitor + item.keyword]
                console.log(isMenuOpen)
                if (isMenuOpen) {
                    console.log("Menu opened:", item, competitor)
                    //set tooltipdata
                    let labels = this.selectedDates[1] == null ? [JSON.parse(JSON.stringify(this.selectedDates[0]))] : JSON.parse(JSON.stringify(this.selectedDates))
                    let datasets = []
                    if (item.rankings) {
                        let ranking = item.rankings.find((e) => e.domain == competitor)
                        if (ranking) {
                            // best ranking
                            let dataset = {
                                label: ranking.url,
                                data: [undefined, ranking.position],
                                borderColor: this.getColoFromIndex(0) || this.getColorFromString(ranking.url),
                                backgroundColor: (this.getColoFromIndex(0) || this.getColorFromString(ranking.url)) + "20",
                                pointBackgroundColor: (this.getColoFromIndex(0) || this.getColorFromString(ranking.url)) + "20",
                                pointStyle: "circle",
                                pointRadius: 6,
                                pointHoverRadius: 10,
                                borderWidth: 2,
                                fill: "start"
                            }
                            datasets.push(dataset)
                            ranking.multiple.forEach((r, index) => {
                                // adding additional rankigns
                                let dataset = {
                                    label: r.url,
                                    data: [undefined, r.position],
                                    borderColor: this.getColoFromIndex(index + 1) || this.getColorFromString(ranking.url),
                                    backgroundColor: (this.getColoFromIndex(index + 1) || this.getColorFromString(ranking.url)) + "20",
                                    pointBackgroundColor: (this.getColoFromIndex(index + 1) || this.getColorFromString(ranking.url)) + "20",
                                    pointStyle: "circle",
                                    pointRadius: 6,
                                    pointHoverRadius: 10,
                                    borderWidth: 2,
                                    fill: "start"
                                }
                                datasets.push(dataset)
                            })
                        }
                    }
                    if (item.rankingsOld) {
                        let rankingOld = item.rankingsOld ? item.rankingsOld.find((e) => e.domain == competitor) : null
                        if (rankingOld) {
                            // find eintrag und setzte ersten data punkt
                            let index = datasets.findIndex((e) => e.label == rankingOld.url)
                            if (index === -1) {
                                let dataset = {
                                    label: rankingOld.url,
                                    data: [rankingOld.position, undefined],
                                    borderColor: this.getColoFromIndex(datasets.length + 1) || this.getColorFromString(rankingOld.url),
                                    backgroundColor: (this.getColoFromIndex(datasets.length + 1) || this.getColorFromString(rankingOld.url)) + "20",
                                    pointBackgroundColor: (this.getColoFromIndex(datasets.length + 1) || this.getColorFromString(rankingOld.url)) + "20",
                                    pointStyle: "circle",
                                    pointRadius: 6,
                                    pointHoverRadius: 10,
                                    borderWidth: 2,
                                    fill: "start"
                                }
                                datasets.push(dataset)
                            } else {
                                datasets[index].data[0] = rankingOld.position
                            }
                            rankingOld.multiple.forEach((r) => {
                                let index = datasets.findIndex((e) => e.label == r.url)
                                // adding additional rankigns
                                if (index === -1) {
                                    let dataset = {
                                        label: r.url,
                                        data: [r.position, undefined],
                                        borderColor: this.getColoFromIndex(datasets.length + 1) || this.getColorFromString(rankingOld.url),
                                        backgroundColor: (this.getColoFromIndex(datasets.length + 1) || this.getColorFromString(rankingOld.url)) + "20",
                                        pointBackgroundColor: (this.getColoFromIndex(datasets.length + 1) || this.getColorFromString(rankingOld.url)) + "20",
                                        pointStyle: "circle",
                                        pointRadius: 6,
                                        pointHoverRadius: 10,
                                        borderWidth: 2,
                                        fill: "start"
                                    }
                                    datasets.push(dataset)
                                } else {
                                    datasets[index].data[0] = r.position
                                }
                            })
                        }
                    }
                    this.tooltipMenuData.labels = labels
                    this.tooltipMenuData.datasets = datasets
                    this.tooltipMenuData.keyword = item.keyword
                    this.tooltipMenuData.domain = competitor
                    this.tooltipMenuData.chartData = {
                        labels: labels,
                        datasets: datasets
                    }
                    this.tooltipMenuData.tableHeaders = [
                        { text: "URL", value: "url" },
                        ...labels.map((l) => {
                            return { text: l.substring(0, 10), value: l, width: "150px" }
                        })
                    ]
                    this.tooltipMenuData.tableRows = this.tooltipMenuData.datasets.map((d) => {
                        let row = { url: d.label }
                        this.tooltipMenuData.labels.forEach((l, index) => {
                            row[l] = d.data[index]
                        })
                        return row
                    })

                    setTimeout(() => {
                        this.renderChart++
                    }, 110)
                } else {
                    console.log("Menu closed:", item, competitor)
                }
            },
            /**
             * fetches Keywords and rankings of 2 dates for given selected Competitors
             * @param {*} project_id
             * @param {*} category_id
             * @param {*} skip
             * @param {*} limit
             * @param {*} sort
             */
            async fetchData(tableOptions) {
                try {
                    this.loading = true
                    console.time("fetch rankings")
                    const [dataForDate1, dataForDate2] = await Promise.all([this.fetchDataForDate(this.selectedDates[0], tableOptions), this.fetchDataForDate(this.selectedDates[1], tableOptions)])
                    console.timeEnd("fetch rankings")
                    if (!dataForDate2.rankings.length) {
                        dataForDate2.rankings = JSON.parse(JSON.stringify(dataForDate1.rankings))
                        dataForDate2.totalCount = JSON.parse(JSON.stringify(dataForDate1.totalCount))
                    }
                    dataForDate1.rankings.map((oldRanking) => {
                        let actualRanking = dataForDate2.rankings.find((r) => r.keyword == oldRanking.keyword)

                        if (actualRanking) {
                            actualRanking.rankingsOld = oldRanking.rankings
                        } else {
                            console.log("couldnt find ranking")
                        }
                    })

                    let mappedRankings = dataForDate2.rankings.map((ranking) => {
                        if (ranking.search_intent) {
                            this.show_intents = true
                            ranking.sorted_search_intent = this.sortIntent(JSON.parse(JSON.stringify(ranking.search_intent)))
                        }
                        if (ranking.amazon_search_volume) {
                            this.show_amazon_sv = true
                        }
                        if (ranking.internal_search_volume !== undefined && ranking.internal_search_volume !== null) {
                            this.show_internal_sv = true
                        }
                        ranking.category_ids.sort()
                        ranking.category_id = ranking.category_ids[ranking.category_ids.length - 1]
                        return ranking
                    })

                    await this.enrichInternalSearchVolume(mappedRankings)

                    this.rankings = mappedRankings
                    this.count = dataForDate2.totalCount ? dataForDate2.totalCount : 0
                    this.loading = false
                    console.log(this.rankings)
                } catch (error) {
                    console.log(error)
                }
            },
            async enrichInternalSearchVolume(rankings) {
                try {
                    if (!this.svColumnsEnabledForCompany) return
                    if (!Array.isArray(rankings) || !rankings.length) return

                    const projectsUrl = process.env.VUE_APP_APIURL + "/internal-searches/projects"
                    const projectsResponse = await this.$helpers.axiosPost(projectsUrl, { company_id: localStorage.company_id })
                    const projects = projectsResponse && projectsResponse.data && projectsResponse.data.projects ? projectsResponse.data.projects : []
                    if (!projects.length) return

                    const normalizeDomain = (value) =>
                        String(value || "")
                            .toLowerCase()
                            .trim()
                            .replace(/^https?:\/\//, "")
                            .replace(/^www\./, "")
                            .replace(/\/.*$/, "")

                    const targetDomain = normalizeDomain(this.project_domain)
                    let selectedProject = projects.find((p) => normalizeDomain(p.domain) === targetDomain) || projects[0]
                    if (!selectedProject || !selectedProject._id) return

                    const normalizeKeywordKey = (value) =>
                        String(value || "")
                            .toLowerCase()
                            .trim()
                            .replace(/\s+/g, " ")

                    const searchesUrl = process.env.VUE_APP_APIURL + "/internal-searches/project/keywords/searches"
                    const searchesResponse = await this.$helpers.axiosPost(searchesUrl, {
                        company_id: localStorage.company_id,
                        project_id: selectedProject._id,
                        keywords: rankings.map((r) => r.keyword)
                    })

                    const keywordSearches = Array.isArray(searchesResponse.data) ? searchesResponse.data : []
                    const svByKeyword = {}
                    keywordSearches.forEach((entry) => {
                        if (!entry || !entry._id || !Array.isArray(entry.data)) return
                        const sortedData = [...entry.data].sort((a, b) => String(b.importDate || "").localeCompare(String(a.importDate || "")))
                        const current = sortedData[0]
                        const previous = sortedData[1]
                        svByKeyword[normalizeKeywordKey(entry._id)] = {
                            current: current && current.search_volume !== undefined ? current.search_volume : null,
                            previous: previous && previous.search_volume !== undefined ? previous.search_volume : null
                        }
                    })

                    rankings.forEach((ranking) => {
                        const entry = svByKeyword[normalizeKeywordKey(ranking.keyword)]
                        if (!entry) return
                        if (entry.current !== null && entry.current !== undefined) {
                            ranking.internal_search_volume = entry.current
                        }
                        ranking.internal_search_volume_prev = entry.previous
                    })
                } catch (error) {
                    console.log(error)
                }
            },
            async fetchDataForDate(date, tableOptions) {
                try {
                    console.log(tableOptions)
                    const domainArray = this.selectedCompetitors.map((c) => c.domain)
                    const url =
                        (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                            this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                        ) == -1
                            ? process.env.VUE_APP_MONITORING_API_URL
                            : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/get/frontend/keywords"
                    const sort = this.getSortObject(tableOptions)
                    console.log(tableOptions.sortDesc)
                    const post_data = {
                        company_id: localStorage.company_id,
                        company_status: this.$store.state.company_status_monitoring_suite,
                        user_id: localStorage.id,
                        project_id: this.$route.params.id,
                        category_id: this.category_id ? this.category_id : null,
                        domains: domainArray,
                        sortDesc: tableOptions.sortDesc[0] ? -1 : 1,
                        date: date, // Use the current date from the loop
                        search: this.search,
                        start: (tableOptions.page - 1) * tableOptions.itemsPerPage,
                        limit: tableOptions.itemsPerPage,
                        sort: sort,
                        filters: this.filters
                    }

                    if (this.sortDomain) {
                        post_data.sortDomain = this.sortDomain
                    }

                    const response_data = await this.$helpers.axiosPost(url, this.withTaxonomy(post_data))
                    return response_data.data
                } catch (error) {
                    console.log(error)
                    throw error
                }
            },
            async deleteKeywords() {
                console.log(this.selectedRows)
                if (!this.selectedRows.length) return
                this.deleteLoading = true
                const url =
                    (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                        this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                    ) == -1
                        ? process.env.VUE_APP_MONITORING_API_URL
                        : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/delete/keywords"
                const post_data = {
                    company_id: localStorage.company_id,
                    project_id: this.$route.params.id,
                    keywords: this.selectedRows,
                    user_id: localStorage.id
                }
                const response_data = await this.$helpers.axiosPost(url, post_data)
                this.fetchData({
                    sortDesc: this.sortDesc,
                    sortBy: this.sortBy,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage
                })
                this.deleteDialog = false
                this.deleteLoading = false
                this.selectedRows = []
                console.log(response_data.data)
                let notifidata = { label: "The selected keywords have been deleted successfully!", icon: "mdi-check-circle-outline", color: "primary" }
                this.$emit("notify", notifidata)
            },
            sortIntent(intent) {
                return Object.entries(intent).sort(([, valueA], [, valueB]) => {
                    if (valueA === null && valueB === null) return 0
                    if (valueA === null) return 1
                    if (valueB === null) return -1
                    return valueB - valueA
                })
            },
            // builds sort object for backend data request
            getSortObject(tableOptions) {
                this.sortDomain = null
                let sort = { avg_search_volume: -1 }
                if (Array.isArray(tableOptions.sortBy) && tableOptions.sortBy.length) {
                    if (tableOptions.sortBy[0].startsWith("ranking")) {
                        this.sortDomain = tableOptions.sortBy[0].substring(8)
                    } else {
                        sort[tableOptions.sortBy[0]] = tableOptions.sortDesc[0] ? -1 : 1
                    }
                }
                if (sort.hasOwnProperty("amazon_search_volume")) {
                    sort = { amazon_search_volume: tableOptions.sortDesc[0] ? -1 : 1 }
                }
                if (sort.hasOwnProperty("internal_search_volume")) {
                    sort = { internal_search_volume: tableOptions.sortDesc[0] ? -1 : 1 }
                }
                return sort
            },
            /**
             * returns pos fpr competitor table
             * @param {*} item
             * @param {*} domain
             */
            getRankingPosition(item, domain) {
                const ranking = item.rankings.find((r) => r.domain === domain)
                // console.log(item)
                const oldRanking = item.rankingsOld ? item.rankingsOld.find((r) => r.domain === domain) : null
                const change = oldRanking && ranking ? ranking.position - oldRanking.position : null
                return { position: ranking ? ranking.position : "-", change: change * -1, ai_reference: ranking && ranking.ai_reference ? ranking.ai_reference : false } // *-1 : 16 --> 20 = +4 sollte aber minuse 4 ergeben daher *-1
            },
            getColor(position) {
                let colorIndex = Math.ceil(position / 10) - 1
                let color = positionColors[colorIndex] ? positionColors[colorIndex] : positionColors[positionColors.length - 1]
                return color
            },
            getColoFromIndex(index) {
                let colors = ["#C2185B", "#7B1FA2", "#1976D2", "#0097A7", "#388E3C", "#AFB42B", "#F57C00", "#5D4037", "#455A64"]
                return colors[index]
            },
            getColorFromString(str) {
                let hash = 0
                for (let i = 0; i < str.length; i++) {
                    hash = str.charCodeAt(i) + ((hash << 5) - hash) + str.length
                }
                const color = Math.floor(Math.abs((Math.sin(hash) * 16777215) % 1) * 16777215).toString(16)
                return "#" + "0".repeat(6 - color.length) + color
            }
        },
        watch: {
            // Beim Umschalten der Kategorisierung neu laden. Noetig auch dann, wenn
            // category_id unveraendert bleibt (Projektebene) und deshalb kein anderer Watcher feuert.
            taxonomyId() {
                this.fetchData({ sortDesc: this.sortDesc, sortBy: this.sortBy, page: this.page, itemsPerPage: this.itemsPerPage })
            },
            selectedCompetitors: {
                handler() {
                    // Fetch data when the domains prop changes
                    this.fetchData({
                        sortDesc: this.sortDesc,
                        sortBy: this.sortBy,
                        page: this.page,
                        itemsPerPage: this.itemsPerPage
                    })
                },
                immediate: false // Fetch data initially when the component is created
            },
            async exportData() {
                console.log("download triggered")
                console.log(this.rankings)
                console.log(this.selectedDates)
                let fields = this.headers.map((header) => header.text)
                let rows = this.rankings.map((ranking) => {
                    let row = {}
                    this.headers.map((header) => {
                        if (header.value.substring(0, 8) == "ranking_") {
                            let compRanking = ranking.rankings.find((r) => r.domain == header.text)
                            row[header.text] = compRanking ? compRanking.position : 0
                            // row[header.text + " - " + this.selectedDates[0]] = ranking.rankingsOld.find((r) => r.domain == header.text)
                        } else if (header.value == "avg_search_volume") {
                            row[header.text] = parseInt(ranking[header.value])
                        } else {
                            row[header.text] = ranking[header.value]
                        }
                    })
                    return row
                })
                console.log(rows, fields)

                let post_data = {
                    rows: rows,
                    fields: fields
                }
                if (this.selectedDates[1]) {
                    post_data.fileTitle = "Rankings_" + this.selectedDates[1].substring(0, 10)
                } else {
                    post_data.fileTitle = "Rankings_" + this.selectedDates[0].substring(0, 10)
                }

                const url =
                    (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                        this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                    ) == -1
                        ? process.env.VUE_APP_MONITORING_API_URL
                        : process.env.VUE_APP_APIURL + "/monitoring-api") + "/project/export/csv"
                let response_data = await this.$helpers.axiosPost(url, post_data)
                window.location =
                    (JSON.parse(process.env.VUE_APP_MONITORING_PROXY_COMPANY_IDS).indexOf(
                        this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)
                    ) == -1
                        ? process.env.VUE_APP_MONITORING_API_URL
                        : process.env.VUE_APP_APIURL + "/monitoring-api") +
                    "/" +
                    response_data.data
            },
            selectedDates() {
                this.fetchData({
                    sortDesc: this.sortDesc,
                    sortBy: this.sortBy,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage
                })
            },
            category_id() {
                this.fetchData({
                    sortDesc: this.sortDesc,
                    sortBy: this.sortBy,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage
                })
            },
            search() {
                // Fetch data when the search query changes
                this.page = 1 // Reset the page to 1 when searching
                this.fetchData({
                    sortDesc: this.sortDesc,
                    sortBy: this.sortBy,
                    page: this.page,
                    itemsPerPage: this.itemsPerPage
                })
            }
        },
        mounted() {
            if (["1547"].includes(this.company_id)) {
                this.headersData.find((e) => e.value == "latest_12_month_search_volume").visible = true
                this.headersData.find((e) => e.value == "avg_search_volume").visible = false
                this.headersData.find((e) => e.value == "item_types").visible = false
            }
        }
    }
</script>

<style lang="scss">
    .blur {
        /* Add the blur effect */
        filter: blur(3px);
        -webkit-filter: blur(3px);
    }
    #urlRankingsTable th {
        background-color: whitesmoke;
    }
    .urlLinkbox {
        border-radius: 5px;
        &:hover {
            background-color: grey !important;
        }
    }
    #rankingstable th {
        white-space: nowrap !important;
    }
    .rtd {
        font-size: 0.98rem !important;
        white-space: nowrap;
    }
    #rankingstable .qchip {
        background-color: rgb(250, 250, 250) !important;
        border-width: 1px;
    }
    #monitoringCompTable .qchip {
        background-color: rgb(250, 250, 250) !important;
        border-width: 1px;
    }
    #trendsTable .qchip {
        background-color: rgb(250, 250, 250) !important;
        border-width: 1px;
    }
    .theme--dark #rankingstable .qchip {
        background-color: black !important;
        border-width: 1px;
    }
    .theme--dark #monitoringCompTable .qchip {
        background-color: black !important;
        border-width: 1px;
    }
    .theme--dark #trendsTable .qchip {
        background-color: black !important;
        border-width: 1px;
    }
    .rankingchange {
        color: grey;
        font-size: 12px;
        /* padding-top: 2px; */
    }
    #rankingstable .internal-sv-change {
        display: inline-flex;
        align-items: center;
    }
    #rankingstable .internal-sv-change__value {
        font-size: 12px;
        line-height: 1;
        font-variant-numeric: tabular-nums;
        color: rgba(0, 0, 0, 0.72);
    }
    .theme--dark #rankingstable .internal-sv-change__value {
        color: rgba(255, 255, 255, 0.78);
    }
    #rankingstable .internal-sv-change__dash {
        font-size: 12px;
        line-height: 1;
        color: rgba(0, 0, 0, 0.38);
        margin-right: 2px;
    }
    .theme--dark #rankingstable .internal-sv-change__dash {
        color: rgba(255, 255, 255, 0.5);
    }
    .compranking-wrapper:hover {
        cursor: pointer;
    }
    #rankingstable #rankinglink:hover {
        color: red !important;
    }
    #rankingstable #rankingslink {
        font-weight: 100;
        color: white !important;
    }
    #rankingstable table > tbody > tr:hover {
        cursor: pointer;
    }
    #trendsTable .theme--light.v-data-table tbody tr.v-data-table__selected {
        background: #8dc4b936 !important;
    }
    /* #rankingstable table > tbody > tr > td:nth-child(1),
    #rankingstable table > tbody > tr > th:nth-child(1) {
        background: var(--v-keywordcol-base) !important;
    }
    #rankingstable table > tbody > tr > td:nth-child(2),
    #rankingstable table > tbody > tr > th:nth-child(2) {
        background: var(--v-keywordcol-base) !important;
    } */
    #rankingstable table > tbody > tr > td:nth-child(3),
    #rankingstable table > thead > tr > th:nth-child(3) {
        /* background: #edeff1 !important; */
        border-left: 2px solid #edeff1;
        border-right: 2px solid #edeff1;
    }
    .theme--dark #rankingstable table > tbody > tr > td:nth-child(3),
    .theme--dark #rankingstable table > thead > tr > th:nth-child(3) {
        /* background: #edeff1 !important; */
        border-left: 2px solid #000000;
        border-right: 2px solid #000000;
    }
    #inspire > div.v-menu__content.theme--light.rounded.menuable__content__active {
        border-radius: 10px !important;
    }
    .intent div.v-progress-linear__determinate.primary {
        opacity: 0.9 !important;
    }
</style>
